import { useEffect } from "react";

interface PageMetaProps {
  title: string;
  description: string;
  path?: string;
  image?: string;
}

const BASE_URL = "https://bunadstuggu.no";
const DEFAULT_IMAGE = `${BASE_URL}/og-image.jpg`;

const PageMeta = ({ title, description, path = "/", image }: PageMetaProps) => {
  useEffect(() => {
    const fullTitle = path === "/" ? title : `${title} | Bunadstuggu`;
    const url = `${BASE_URL}${path}`;
    const ogImage = image || DEFAULT_IMAGE;

    document.title = fullTitle;

    const setMeta = (attr: string, key: string, content: string) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", ogImage);
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", ogImage);

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    return () => {
      // Reset to defaults on unmount
      document.title = "Norskproduserte bunader sydd i Norge | Bunadstuggu";
    };
  }, [title, description, path, image]);

  return null;
};

export default PageMeta;
